import { types } from 'mobx-state-tree';

export const MoneyInfoForPeriod = types.model({
    // идентификатор, а не просто строка: годы накладных перезагружаются через
    // applySnapshot, и без него каждый узел пересоздавался, а старый продолжал
    // уходить пропом в карточку года (рабочий элемент #27)
    period: types.identifier,
    actualSum: types.number,
    planSum: types.number,
    loading: types.optional(types.boolean, false)
}).named('MoneyInfoForPeriod');
